'use client';
import { isBrowser } from '../platform/isBrowser.js';

/**
 * Поддерживаются ли пассивные события в контексте исполнения.
 *
 * @remarks
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#passive
 *
 * Свойство `passive`, когда задано, является индикатором того, что .preventDefault() никогда не будет вызвано.
 * Вызов .preventDefault() будет приводить лишь к console.warn.
 *
 * По-умолчанию задано как true для событий `wheel`, `mousewheel`, `touchstart`, `touchmove`.
 *
 * Пассивные события можно воспринимать как оптимизационную технику.
 * Оптимизация достигается за счёт того, что браузер может немедленно начать выполнение
 * "действия по-умолчанию" без необходимости дожидаться, пока listener завершит работу.
 * То есть, так как событие не может быть отменено, невозможна и блокировка рендеринга
 * страницы, пока пользователь, например, выполняет прокрутку.
 * */ const supportsPassiveEvents = (()=>{
    let hasSupport = false;
    if (isBrowser) {
        const passiveTestOptions = {
            get passive () {
                hasSupport = true;
                return undefined;
            }
        };
        try {
            window.addEventListener('t', null, passiveTestOptions);
            window.removeEventListener('t', null, passiveTestOptions);
        } catch (e) {
        /* empty */ }
    }
    return hasSupport;
})();

export { supportsPassiveEvents };
//# sourceMappingURL=supportsPassiveEvents.js.map
